<template>
  <el-card shadow="never" class="info-card">
    <el-row>
      <el-col :span="2" class="item-text">当前工站：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站状态：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_status_name }}</el-col>
      <el-col :span="2" class="item-text">当前工站责任人：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_user_name }}</el-col>
      <el-col :span="2" class="item-text">品牌：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.brand_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">SN：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.sn }}</el-col>
      <el-col :span="2" class="item-text">CID/VID：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.cid }}</el-col>
      <el-col :span="2" class="item-text">型号：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.model }}</el-col>
      <el-col :span="2" class="item-text">品类：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.catalog_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">IW/OOW：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.iw_oow }}</el-col>
      <el-col :span="2" class="item-text">料号：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.material_code }}</el-col>
      <el-col :span="2" class="item-text">送修类别：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.send_repair_type }}</el-col>
      <el-col :span="2" class="item-text">故障现象：</el-col>
      <el-col :span="6" class="item-value">{{ busItem.trouble_desc }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">是否是二返：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.is_two_return }}</el-col>
      <el-col :span="2" class="item-text">上次维修时间：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.prev_repair_time }}</el-col>
      <el-col :span="2" class="item-text">来货次数：</el-col>
      <el-col :span="10" class="item-value">{{ busItem.in_line_cnt }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">上次维修人员：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.prev_repair_user_name }}</el-col>
      <el-col :span="2" class="item-text">上次测试人员：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.prev_test_user_name }}</el-col>
      <el-col :span="2" class="item-text">发板指定维修人：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.assign_repair_user_name }}</el-col>
    </el-row>

  </el-card>
</template>

<script>
export default {
  name: "StationInfo",
  props: {
    busItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>